
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[park]/an-uong",
      function () {
        return require("private-next-pages/[park]/an-uong/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[park]/an-uong"])
      });
    }
  